module.exports = __webpack_public_path__ + "static/media/icon_coin.1cc448d0.png";